module.exports = __webpack_public_path__ + "static/media/R6.39493571.jpg";